import { gql } from '@apollo/client';

export const SET_AWAY_SCORE = gql`
  mutation SetAwayScore($gameId: Int!, $awayScore: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { awayScore: $awayScore }
    ) {
      id
    }
  }
`;

export const SET_HOME_SCORE = gql`
  mutation SetHomeScore($gameId: Int!, $homeScore: Int!) {
    update_schedule_by_pk(
      pk_columns: { id: $gameId }
      _set: { homeScore: $homeScore }
    ) {
      id
    }
  }
`;
